import { createStyles, Theme } from '@material-ui/core/styles';


const tabletWidth = 1280;
const drawerWidth = 240;
const menuBackgroundColor = '#F0F1F4';

const styles = (theme: Theme) => createStyles({
  root: {
    display: 'flex',
  },
  appBar: {
    backgroundColor: '#FFF',
    boxShadow: 'none',
    [theme.breakpoints.up(tabletWidth)]: {
      width: '100%',
    },
    [theme.breakpoints.down(600)]: {
      height: 56,
    },
    [theme.breakpoints.up('lg')]: {
      paddingLeft: '240px'
    },
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    backgroundColor: 'white',
    [theme.breakpoints.up(tabletWidth)]: {
      width: '100%',
    },
  },
  menuButton: {
    color: 'rgb(197, 197, 197)',
    display: 'flex',
    [theme.breakpoints.up('lg')]: {
      width: 240,
      display: 'none'
    },
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    [theme.breakpoints.down(tabletWidth)]: {
      position: 'fixed',
      zIndex: 1200,
      opacity: 0.9,
    },
  },
  drawerOpen: {
    width: drawerWidth,
    backgroundColor: menuBackgroundColor,
    border: 0,
    // boxShadow: '2px 0 6px 0 rgba(31, 48, 63, 0.3);',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
    ...theme.mixins.toolbar,
    backgroundColor: '#FFF',
    paddingLeft: 0,
    '& > a': {
      height: '20px',
    }
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    marginTop: 64,
  },
  snackbarContent: {
    width: 360,
  },
  logo: {
    width: 145,
    height: 20,
  },
  logoBlock: {
    width: '100%',
    display: 'flex',
    padding: '20px',
    backgroundColor: menuBackgroundColor,
  },
  isDisabled: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    zIndex: 9999,
    backgroundColor: 'black',
    opacity: 0.5,
  },
});

export default styles;
